// extracted by mini-css-extract-plugin
export default {"title":"Services_title__wDa67","serviceItems":"Services_serviceItems__YJ6jE","serviceItem":"Services_serviceItem__CFpDm","serviceName":"Services_serviceName__A6JG9"};